//  Copyright (c) 2021 First Foundry Inc. All rights reserved.

export const PATH = 'budtenderDetailed'
export const SET_START_DATE = `${PATH}/SET_START_DATE`
export const SET_END_DATE = `${PATH}/SET_END_DATE`
export const OPEN_BUDTENDER_DETAILED_REPORT_LIST = `${PATH}/OPEN_BUDTENDER_DETAILED_REPORT_LIST`
